import { Injectable } from '@angular/core';
import { EMPTY, Observable, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class DirectoryStateService {

  private readonly EXPANDED_KEY = 'expandedFolderIds';
  private readonly FOLDER_TAB_STATE_KEY = 'folderTabState';
  private readonly SELECTED_KEY = 'selectedFolderIds';
  private readonly AUTO_SELECT_KEY = 'autoSelectSubfolders';
  private readonly PPWR_VIEW_KEY = 'isPpwrViewEnabled';

  saveExpandedFolders(ids: number[]): Observable<void> {
      localStorage.setItem(this.EXPANDED_KEY, JSON.stringify(ids));
      return EMPTY;
    }

    getExpandedFolderIds(): Observable<number[]> {
      const raw = localStorage.getItem(this.EXPANDED_KEY);
      const ids = raw ? JSON.parse(raw) : [];
      return of(ids);
    }

    saveFolderAndTab(folderId: number, tabIndex: number): Observable<void> {
      const state = { folderId, tabIndex };
      localStorage.setItem(this.FOLDER_TAB_STATE_KEY, JSON.stringify(state));
      return EMPTY;
    }

    getFolderAndTab(): Observable<{ folderId: number; tabIndex: number } | null> {
      const raw = localStorage.getItem(this.FOLDER_TAB_STATE_KEY);
      const result = raw ? JSON.parse(raw) : null;
      return of(result);
    }

    savePpwrViewEnabled(enabled: boolean): Observable<void> {
      localStorage.setItem(this.PPWR_VIEW_KEY, JSON.stringify(enabled));
      return EMPTY;
    }

    getPpwrViewEnabled(): Observable<boolean> {
      const raw = localStorage.getItem(this.PPWR_VIEW_KEY);
      return of(raw === null ? false : JSON.parse(raw));
    }

    saveSelectedFolders(ids: number[]): Observable<void> {
       localStorage.setItem(this.SELECTED_KEY, JSON.stringify(ids));
      return EMPTY;
    }

    getSelectedFolderIds(): Observable<number[]> {
      const raw = localStorage.getItem(this.SELECTED_KEY);
      return of(raw ? JSON.parse(raw) : []);
    }

    saveAutoSelectSubfolders(enabled: boolean): Observable<void> {
      localStorage.setItem(this.AUTO_SELECT_KEY, JSON.stringify(enabled));
      return EMPTY;
    }

    getAutoSelectSubfolders(): Observable<boolean> {
      const raw = localStorage.getItem(this.AUTO_SELECT_KEY);
      return of(raw === null ? true : JSON.parse(raw));
    }

    clearSelectedFolders(): Observable<void> {
      localStorage.removeItem(this.SELECTED_KEY);
      return EMPTY;
    }

    clearAll(): void {
      localStorage.removeItem(this.FOLDER_TAB_STATE_KEY);
      localStorage.removeItem(this.PPWR_VIEW_KEY);
      localStorage.removeItem(this.SELECTED_KEY);
      localStorage.removeItem(this.AUTO_SELECT_KEY);
    }

  constructor() { }
  }
